import { useFormState } from "react-final-form";
import { FunctionField } from "react-admin";
import moment from 'moment'
// import StarPicker from "react-star-picker";
import { Add } from '@material-ui/icons';
import { ExternalInformationClient } from "../../services/ohl.virtualCenter.api";
import { useEffect, useState } from "react";

import { mapaPestanas, PESTANA_CONTRATOS, PESTANA_HORARIO, PESTANA_USUARIOS } from "./utils";
import weeklyScheduleProvider from "../../provider/WeeklySchedule.provider";

const formatearFecha = (fecha) => fecha ? moment(fecha).format('DD/MM/YYYY') : ''
const externalInformationClient = new ExternalInformationClient(process.env.REACT_APP_PUBLIC_API)

export const PanelVariado = (props) => {

    const [lastInteraction, setLastInteraction] = useState();
    const [weeklySchedules, setWeeklySchedules] = useState([]);

    const { values } = useFormState();
    const statusLabel = {
        ACTIVE: 'ACTIVO',
        INACTIVE: 'INACTIVO',
        LEAVE: 'BAJA',
    }

    const indicePestana = (pestana) => {
        return mapaPestanas[pestana][props.identity.roles]
    }

    useEffect(() => {
        externalInformationClient.lastInteraction({ clientId: values?.id }).then(interaction => setLastInteraction(interaction))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    useEffect(() => {

        if (props?.record?.id) fetchWeeklySchedules(props?.record?.id)
        // eslint-disable-next-line
    }, []);

    const fetchWeeklySchedules = async (filterId) => {
        const res = await weeklyScheduleProvider.getList(null, {
            pagination: { page: 1, perPage: 10 },
            sort: { field: 'Id', order: 'DESC' },
            filter: {
                clientId: filterId,
            }
        });
        setWeeklySchedules(res?.data);
    };

    const getTimeForDay = (indexDay, position) => {
        if (weeklySchedules && weeklySchedules.length > 0) {
            const weeklySchedul = weeklySchedules.find(f => f.dayOrder === (indexDay === 6 ? 0 : indexDay + 1));
            
            if (!weeklySchedul?.timeBlocks) return '';
    
            // Encontrar el timeBlock correspondiente según el order
            const timeBlock0 = weeklySchedul.timeBlocks.find(tb => tb.order === 1);
            const timeBlock1 = weeklySchedul.timeBlocks.find(tb => tb.order === 2);
    
            switch (position) {
                case 0:
                    return timeBlock0?.startTimeTS || "";
                case 1:
                    return timeBlock0?.endTimeTS || "";
                case 2:
                    return timeBlock1?.startTimeTS || "";
                case 3:
                    return timeBlock1?.endTimeTS || "";
                default:
                    return '';
            }
        }
        return '';
    };

    return (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '3rem', width: '100%', minHeight: '10rem' }}>
            <div style={{
                display: 'flex', flexDirection: 'column', gap: 8,
                backgroundColor: '#f0f0f0', borderRadius: '8px', padding: 8
            }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 6 }}>
                    <h3>Contratos</h3>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 6, width: '100%' }}>
                        {
                            props.identity.roles !== 'USER_HISTORY_MANAGER' && props.identity.roles !== 'AAPP_TECHNICIAN' ?
                                <>
                                    <FunctionField style={{
                                        backgroundColor: '#00ab8e', borderRadius: '20px', height: 'fit-content',
                                        textAlign: 'center', paddingLeft: '8px', paddingRight: '8px', color: 'white'
                                    }}
                                        render={record => values.contracts?.find(c => c?.id === record.mainContractId)?.contractNumber}
                                    />
                                    <a style={{ color: '#00ab8e', textDecoration: 'none' }}
                                        href={`/#/users/${values?.id}/${indicePestana(PESTANA_CONTRATOS)}`}>
                                        <Add />
                                    </a>
                                </> : null
                        }
                    </div>
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, backgroundColor: 'white', padding: 10, borderRadius: 8, height: '100%' }}>
                    {
                        props.identity.roles !== 'USER_HISTORY_MANAGER' && props.identity.roles !== 'AAPP_TECHNICIAN' && values.contracts?.map(c => <FunctionField style={{
                            backgroundColor: '#00ab8e', borderRadius: '20px', height: 'fit-content',
                            textAlign: 'center', paddingLeft: '8px', paddingRight: '8px', color: 'white'
                        }}
                            render={record => c?.contractNumber} />)
                    }
                </div>
                {
                    props.identity.roles !== 'USER_HISTORY_MANAGER' && props.identity.roles !== 'AAPP_TECHNICIAN' ?
                        <div style={{ display: 'flex', justifyContent: 'end' }}>
                            <a href={`/#/users/${values?.id}/${indicePestana(PESTANA_CONTRATOS)}`} style={{
                                backgroundColor: '#aaaaaa', borderRadius: '20px', height: 'fit-content',
                                textAlign: 'center', paddingLeft: '8px', paddingRight: '8px', color: 'white', textDecoration: 'none'
                            }} >Ver Más</a>
                        </div>
                        : null
                }
            </div>
            <div style={{
                display: 'flex', flexDirection: 'column', gap: 8,
                backgroundColor: '#f0f0f0', borderRadius: '8px', padding: 8
            }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 6 }}>
                    <h3>Servicios contratados</h3>
                    <span style={{ color: '#00ab8e', textDecoration: 'none', cursor: 'pointer' }}
                    // href={`/#/users/${values?.id}/8`}
                    >
                       {/*  <Add /> */}
                    </span>
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, backgroundColor: 'white', padding: 10, borderRadius: 8, height: '100%' }}>
                    {
                        props.identity.roles !== 'USER_HISTORY_MANAGER' && props.identity.roles !== 'AAPP_TECHNICIAN' && values.servicePackages?.map(c => <FunctionField style={{
                            backgroundColor: '#00ab8e', borderRadius: '20px', height: 'fit-content',
                            textAlign: 'center', paddingLeft: '8px', paddingRight: '8px', color: 'white'
                        }}
                            render={record => c?.name} />)
                    }
                </div>
                <div style={{ display: 'flex', justifyContent: 'end' }}>
                    <a href={`/#/users/${values?.id}/${indicePestana(PESTANA_USUARIOS)}`} style={{
                                backgroundColor: '#aaaaaa', borderRadius: '20px', height: 'fit-content',
                                textAlign: 'center', paddingLeft: '8px', paddingRight: '8px', color: 'white', textDecoration: 'none'
                            }} >Ver Más</a>
                </div>
            </div>
            <div style={{
                display: 'flex', flexDirection: 'column', gap: 8,
                backgroundColor: '#f0f0f0', borderRadius: '8px', padding: 8
            }}>
                <h3>Registro de actividad</h3>
                <div style={{backgroundColor: 'white', height: '100%'}}>
                    
                    <div style={{
                        display: 'grid', gridTemplateColumns: 'auto auto', columnGap: 8, whiteSpace: 'nowrap',
                        backgroundColor: 'white', padding: 10, borderRadius: 8, height: '66%'
                    }}>
                        <div>
                            <FunctionField render={record => "Fecha alta: "} />
                            <FunctionField style={{ fontWeight: 'bold' }} render={record => formatearFecha(record.activeDate)} />
                        </div>
                        <div>
                            <FunctionField render={record => "Estado: "} />
                            <FunctionField style={{ fontWeight: 'bold' }} render={record => statusLabel[record.active]} />
                        </div>

                        <div>
                            <FunctionField render={record => "Fecha baja: "} />
                            <FunctionField style={{ fontWeight: 'bold' }} render={record => formatearFecha(record.leavingDate)} />
                        </div>

                        <div>
                            <FunctionField render={record => "Última sesión: "} />
                            <FunctionField style={{ fontWeight: 'bold' }} render={record => (props.identity.roles !== 'USER_HISTORY_MANAGER' && props.identity.roles !== 'AAPP_TECHNICIAN' ? formatearFecha(lastInteraction?.creationDate) : '')} />
                        </div>

                        <div>
                            <FunctionField render={record => "Fecha inactividad: "} />
                            <FunctionField style={{ fontWeight: 'bold' }} render={record => formatearFecha(record.inactivityDate)} />
                        </div>
                    </div>
                </div>
                
            </div>
            <div style={{
                display: 'flex', flexDirection: 'column', gap: 4,
                backgroundColor: '#f0f0f0', borderRadius: '8px', padding: 6
            }}>
                <div style={{display: 'flex', placeContent: 'space-between'}}>
                <h3 style={{ margin: 0, fontSize: '14px' }}>Disponibilidad</h3>
                <a href={`/#/users/${values?.id}/${indicePestana(PESTANA_HORARIO)}`} style={{
                                backgroundColor: '#aaaaaa', borderRadius: '20px', height: 'fit-content',
                                textAlign: 'center', paddingLeft: '8px', paddingRight: '8px', color: 'white', textDecoration: 'none'
                            }} >Ver Más</a>
                </div>
                
                <div style={{ backgroundColor: 'white', borderRadius: 6, padding: 4 }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                        <thead>
                            <tr style={{ borderBottom: '1px solid #eee', fontSize: '11px' }}>
                                <th style={{ textAlign: 'left', padding: '4px 6px', width: '22%' }}>Día</th>
                                <th style={{ textAlign: 'center', padding: '4px 2px', width: '19%' }}>Inicio Mañana</th>
                                <th style={{ textAlign: 'center', padding: '4px 2px', width: '19%' }}>Fin Mañana</th>
                                <th style={{ textAlign: 'center', padding: '4px 2px', width: '19%' }}>Inicio Tarde</th>
                                <th style={{ textAlign: 'center', padding: '4px 2px', width: '19%' }}>Fin Tarde</th>
                            </tr>
                        </thead>
                        <tbody>
                            {['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes'].map((day, index) => {

                                return (
                                    <tr key={day} style={{ borderTop: '1px solid #f5f5f5' }}>
                                        <td style={{ padding: '4px 6px' }}>{day}</td>

                                        <td style={{ padding: '2px', textAlign: 'center' }}>
                                            <input
                                                disabled={true}
                                                type="text"
                                                placeholder="--:--"
                                                style={{
                                                    border: '1px solid #ddd',
                                                    borderRadius: '3px',
                                                    padding: '3px 4px',
                                                    width: '100%',
                                                    maxWidth: '50px',
                                                    fontSize: '11px',
                                                    textAlign: 'center'
                                                }}
                                                defaultValue={getTimeForDay(index, 0)}
                                            />
                                        </td>
                                        <td style={{ padding: '2px', textAlign: 'center' }}>
                                            <input
                                                disabled={true}
                                                type="text"
                                                placeholder="--:--"
                                                style={{
                                                    border: '1px solid #ddd',
                                                    borderRadius: '3px',
                                                    padding: '3px 4px',
                                                    width: '100%',
                                                    maxWidth: '50px',
                                                    fontSize: '11px',
                                                    textAlign: 'center'
                                                }}
                                                defaultValue={getTimeForDay(index, 1)}
                                            />
                                        </td>
                                        <td style={{ padding: '2px', textAlign: 'center' }}>
                                            <input
                                                disabled={true}
                                                type="text"
                                                placeholder="--:--"
                                                style={{
                                                    border: '1px solid #ddd',
                                                    borderRadius: '3px',
                                                    padding: '3px 4px',
                                                    width: '100%',
                                                    maxWidth: '50px',
                                                    fontSize: '11px',
                                                    textAlign: 'center'
                                                }}
                                                defaultValue={getTimeForDay(index, 2)}
                                            />
                                        </td>
                                        <td style={{ padding: '2px', textAlign: 'center' }}>
                                            <input
                                                disabled={true}
                                                type="text"
                                                placeholder="--:--"
                                                style={{
                                                    border: '1px solid #ddd',
                                                    borderRadius: '3px',
                                                    padding: '3px 4px',
                                                    width: '100%',
                                                    maxWidth: '50px',
                                                    fontSize: '11px',
                                                    textAlign: 'center'
                                                }}
                                                defaultValue={getTimeForDay(index, 3)}
                                            />
                                        </td>
                                    </tr>
                                )

                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}